module.exports = __webpack_public_path__ + "static/img/expressway-text-2.3fbc819e.png";